import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { XCircle, CheckCircle, Info } from "lucide-react";
import { useToastStore } from "store/toastStore";

const Toast = () => {
  const { message, type, hideToast } = useToastStore();

  // Auto-hide the toast after 5 seconds
  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        hideToast();
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [message, hideToast]);

  if (!message) return null;

  const toastStyles = {
    success: "bg-gradient-to-r from-green-500 to-green-600 text-white",
    error: "bg-gradient-to-r from-red-500 to-red-600 text-white",
    info: "bg-gradient-to-r from-blue-500 to-blue-600 text-white",
  };

  const iconContainerStyles = {
    success: "bg-green-600",
    error: "bg-red-600",
    info: "bg-blue-600",
  };

  const icons = {
    success: <CheckCircle className="w-5 h-5" />,
    error: <XCircle className="w-5 h-5" />,
    info: <Info className="w-5 h-5" />,
  };

  return createPortal(
    <div className="fixed top-24 right-6" style={{ zIndex: 99999 }}>
      <div
        className={`flex items-center overflow-hidden rounded-lg shadow-2xl transform transition-all duration-300 ease-in-out animate-slideIn ${toastStyles[type ?? "info"]}`}
        style={{ maxWidth: "400px" }}
      >
        <div className={`flex items-center justify-center p-4 ${iconContainerStyles[type ?? "info"]}`}>
          {icons[type ?? "info"]}
        </div>
        <div className="flex-1 p-4">
          <p className="font-medium">{message}</p>
        </div>
        <button
          onClick={hideToast}
          className="p-4 hover:bg-black hover:bg-opacity-10 transition-colors duration-200 focus:outline-none"
          aria-label="Close"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>,
    document.body
  );
};

// Add this to your global CSS or at the component level
const globalStyles = `
@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.animate-slideIn {
  animation: slideIn 0.3s forwards;
}
`;

export default Toast;